import * as R from 'ramda'
import React, { useState, MouseEvent, ChangeEvent, FormEvent } from 'react'
import { Radio, Form, InputOnChangeData } from 'semantic-ui-react'
import CustomUserAccessBox from './CustomUserAccessBox'
import { UserAccess } from './index'

type Props = {
  currentUserId: number
  users: UserAccess[]
  clearAllOptions: (event: MouseEvent) => void
  onCheckboxChange: (user: UserAccess) => void
  selectAllOptions: (event: MouseEvent | FormEvent) => void
}
export default function SurveyAccessModalContent({
  currentUserId,
  users,
  clearAllOptions,
  onCheckboxChange,
  selectAllOptions,
}: Props) {
  const initialSelectedAll: boolean = R.all((user) => user.has_permission, users)
  const [isSelectedAll, setIsSelectedAll] = useState(initialSelectedAll)

  const [userSearch, setUserSearch] = useState('')
  function handleSearchChange(_: ChangeEvent, { value }: InputOnChangeData) {
    setUserSearch(value)
  }

  const filteredUsers = users.filter((user) => {
    if (userSearch) {
      const foundSearchAtIndex = user.name.search(
        new RegExp(userSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i')
      )
      return foundSearchAtIndex > -1
    }
    return true
  })

  const hasUsers = users.length > 0 ? true : false

  return (
    <Form className="mb3">
      <Form.Group grouped>
        <Form.Field>
          <Radio
            label="All users in this account"
            name="userAccessOption"
            checked={isSelectedAll}
            onChange={(event) => {
              setIsSelectedAll(!isSelectedAll)
              selectAllOptions(event)
            }}
          />
        </Form.Field>
        <Form.Field>
          <Radio
            label="All users with full survey access, plus the following users who require individual access:"
            name="userAccessOption"
            checked={!isSelectedAll}
            onChange={() => setIsSelectedAll(!isSelectedAll)}
          />
        </Form.Field>
      </Form.Group>
      {isSelectedAll ? null : (
        <CustomUserAccessBox
          clearAllOptions={clearAllOptions}
          currentUserId={currentUserId}
          handleSearchChange={handleSearchChange}
          onCheckboxChange={onCheckboxChange}
          hasUsers={hasUsers}
          users={filteredUsers}
          selectAllOptions={selectAllOptions}
        />
      )}
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/SurveyAccessFormModal/SurveyAccessModalContent.tsx